import React, { useRef, useEffect, useState } from 'react';
import mapboxgl from 'mapbox-gl';
import ReactDOMServer from 'react-dom/server';
import { Fab, Box } from "@mui/material";
import SendIcon from '@mui/icons-material/Send';
import SavedSearchIcon from '@mui/icons-material/SavedSearch';
import PersonPinIcon from '@mui/icons-material/PersonPin';
import SearchIcon from '@mui/icons-material/Search';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { IconButton } from '@mui/material';
import StadiumIcon from '@mui/icons-material/Stadium';
import QrCodeScannerIcon from '@mui/icons-material/QrCodeScanner';
import ChecklistIcon from '@mui/icons-material/Checklist';
import axios from 'axios';
import Search from './Search';
import SearchResultCard from './SearchResultCard';
import SearchOrderResultCard from './SearchOrderResultCard';
import SearchUserResultCard from './SearchUserResultCard';
import SearchDriverResultCard from './SearchDriverResultCard';
import MapIcon from '@mui/icons-material/Map';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { districts } from '../user/utils/Districs';

mapboxgl.accessToken = process.env.REACT_APP_MAPBOX_ACCESS_TOKEN;


function MapAdmin({ setActiveComponent, onOptionClick, userId }) {
    const mapContainerRef = useRef(null);
    const mapRef = useRef(null);
    const driverMarkersRef = useRef({});
    const [userMarker, setUserMarker] = useState(null);
    const [user, setUser] = useState(null)
    const [deliveryPoints, setDeliveryPoints] = useState([]);
    const [orderPoints, setOrderPoints] = useState([]);
    const [drivers, setDrivers] = useState([]);
    const [isSearchModalOpen, setIsSearchModalOpen] = useState(false);
    const [searchResult, setSearchResult] = useState(null);
    const [currentMarkers, setCurrentMarkers] = useState([]);


    useEffect(() => {
        axios.get(`${process.env.REACT_APP_API_URL}/api/user/${userId}`)
          .then(response => {
            setUser(response.data);
            console.log('user ', response.data);
          })
          .catch(error => console.error('Error fetching data:', error));
      }, [userId]);

      useEffect(() => {
        const POLL_MS = 6000;
        let timer;
        let inFlight = false;
        let stopped = false;
        const ctrl = new AbortController();

        const tick = async () => {
            if (stopped || inFlight) return;
            inFlight = true;
            try {
            const res = await axios.get(
                `${process.env.REACT_APP_API_URL}/api/driver/location`,
                { signal: ctrl.signal }
            );
            if (!stopped) {
                const data = res.data;
                setDrivers(data);

                // ideally update existing markers instead of re-adding each time
                data.forEach(driver => addDriverMarker(driver));
            }
            } catch (err) {
            if (!(err?.name === 'CanceledError' || err?.code === 'ERR_CANCELED')) {
                console.error('Error fetching drivers:', err);
            }
            } finally {
            inFlight = false;
            if (!stopped) timer = setTimeout(tick, POLL_MS);
            }
        };

        tick();

        return () => {
            stopped = true;
            ctrl.abort();
            clearTimeout(timer);
        };
        }, []);


    useEffect(() => {
        const POLL_MS = 5000;
        let timer;
        let inFlight = false;
        let stopped = false;
        const ctrl = new AbortController();

        const tick = async () => {
            if (stopped || inFlight) return;   // prevent overlap & stop when unmounted
            inFlight = true;
            try {
            const res = await axios.get(
                `${process.env.REACT_APP_API_URL}/api/delivery_points/admin`,
                { signal: ctrl.signal }
            );
            if (!stopped) {
                // console.log("Fetched delivery points:", res.data);
                setDeliveryPoints(res.data);
            }
            } catch (err) {
            // ignore cancellation; log real errors
            if (!(err?.name === 'CanceledError' || err?.code === 'ERR_CANCELED')) {
                console.error("Error fetching delivery points:", err);
            }
            } finally {
            inFlight = false;
            if (!stopped) timer = setTimeout(tick, POLL_MS); // schedule next AFTER finish
            }
        };

        tick(); // initial fetch

        return () => {
            stopped = true;
            ctrl.abort();           // cancels any in-flight request
            clearTimeout(timer);    // stops future ticks
        };
        }, []);




    useEffect(() => {
        const fetchOrders = async () => {
            try {
                
                const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/delivery_orders/admin`);
                console.log("Fetched orders:", response.data);
                setOrderPoints(response.data);
            } catch (error) {
                console.error("Error fetching orders:", error);
            }
        };

        fetchOrders();
    }, [deliveryPoints]);


    
    
    const addDriverMarker = (driver) => {
        if (mapRef.current) {
            if (driverMarkersRef.current[driver.id]) {
                driverMarkersRef.current[driver.id].setMap(null);
            }

            const driverLatLng = new window.google.maps.LatLng(driver.latitude, driver.longitude);
            const driverIconElement = {
                url: `${process.env.PUBLIC_URL}/logo.png`,
                scaledSize: new window.google.maps.Size(25, 25),
            };

            const marker = new window.google.maps.Marker({
                position: driverLatLng,
                map: mapRef.current,
                icon: driverIconElement,
            });

            marker.addListener('click', () => handleDriverMarkerClick(driver.id));
            driverMarkersRef.current[driver.id] = marker;
        }
    };



    const addUserMarker = (address) => {
        if (mapRef.current) {
            const userLatLng = new window.google.maps.LatLng(address.latitude, address.longitude);
            const storeIconElement = {
                url: 'https://maps.google.com/mapfiles/kml/shapes/homegardenbusiness.png',
                scaledSize: new window.google.maps.Size(40, 40),
            };

            const marker = new window.google.maps.Marker({
                position: userLatLng,
                map: mapRef.current,
                icon: storeIconElement,
            });

            const infowindow = new window.google.maps.InfoWindow({
                content: `<h2 style="color: black;">${user.username}</h2><p>${address.address}</p>`,
            });

            marker.addListener('click', () => {
                infowindow.open(mapRef.current, marker);
            });

            setUserMarker(marker);
        }
    };

      useEffect(() => {
        // Load Google Maps script
        const loadGoogleMapsScript = () => {
            if (!window.google) {
                const script = document.createElement('script');
                script.src = `https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}`;
                script.async = true;
                script.defer = true;
                script.onload = () => initMap();
                document.head.appendChild(script);
            } else {
                initMap();
            }
        };

        const initMap = () => {
            if (mapContainerRef.current) {
                const mapInstance = new window.google.maps.Map(mapContainerRef.current, {
                    center: { lat: -12.060235303763926, lng: -77.03711992646711 },
                    zoom: 12,
                    disableDefaultUI: true,
                });

                mapRef.current = mapInstance;

                if (user && user.addresses && user.addresses.length > 0) {
                    user.addresses.forEach(address => {
                        if (address.latitude && address.longitude) {
                            addUserMarker(address);
                        }
                    });
                }

                fitMapToMarkers();
            }
        };

        loadGoogleMapsScript();
    }, [user]);

    const clearMarkers = () => {
        currentMarkers.forEach(marker => marker.setMap(null));
        setCurrentMarkers([]);
    };


    const fitMapToMarkers = () => {
        if (mapRef.current) {
            const bounds = new window.google.maps.LatLngBounds();

            if (user && user.default_latitude && user.default_longitude) {
                bounds.extend(new window.google.maps.LatLng(user.default_latitude, user.default_longitude));
            }

            deliveryPoints.forEach(point => {
                if (point.latitude && point.longitude) {
                    bounds.extend(new window.google.maps.LatLng(point.latitude, point.longitude));
                }
            });

            drivers.forEach(driver => {
                if (driver.latitude && driver.longitude) {
                    bounds.extend(new window.google.maps.LatLng(driver.latitude, driver.longitude));
                }
            });

            if (!bounds.isEmpty()) {
                mapRef.current.fitBounds(bounds, { padding: 50 });
            }
        }
    };
   

    useEffect(() => {
        console.log('Delivery a points:', deliveryPoints);
    }, [deliveryPoints]);


    const handleEntregasClick = async () => {
        console.log("Fetching delivery points…");

        clearMarkers();

        // slot→color map
        const slotColors = {
            1: '#BF360C',  // deep burnt orange (most urgent)
            2: '#E65100',  // darker orange
            3: '#F57C00',  // medium orange
            4: '#FFB74D',  // light orange
            5: '#FFE0B2',  // pale peach (least urgent)
        };

        deliveryPoints.forEach(point => {
            let { latitude, longitude, status, driver_id, slot } = point;

            // fallback coords from district
            if (!latitude || !longitude) {
            const d = districts[point.district];
            if (d) {
                latitude  = d.latitude  + (Math.random() - 0.5) * 0.01;
                longitude = d.longitude + (Math.random() - 0.5) * 0.01;
            }
            }

            if (latitude && longitude) {
            // 1) determine main circle color
            let color;
            if (status === 'pending') {
                switch (driver_id) {
                case 3:   color = 'lightblue';             break;
                case 183: color = 'lightgreen';            break;
                case 6:   color = 'lightpink';             break;
                case 7:   color = 'peachpuff';             break;
                case 8:   color = 'lightcoral';            break;
                case 54:  color = 'lightgoldenrodyellow';  break;
                case 191: color = 'plum';                  break;
                case 164: color = 'mediumaquamarine';      break;
                case 119: color = 'lightsalmon';           break;
                case 4: color = 'lightseagreen';           break;
                case 240: color = 'lightcyan';             break;
                default:  color = 'gray';                  break;
                }
            } else {
                switch (status) {
                case 'entregado': color = 'green';  break;
                case 'cancel':    color = 'red';    break;
                case 'encamino':  color = 'orange'; break;
                default:          color = 'blue';   break;
                }
            }

            const position = { lat: latitude, lng: longitude };

            // 2) render the circle marker
            const marker = new window.google.maps.Marker({
                position,
                map: mapRef.current,
                icon: {
                path: window.google.maps.SymbolPath.CIRCLE,
                fillColor: color,
                fillOpacity: 1,
                scale: 12,
                strokeColor: 'black',
                strokeWeight: 1,
                },
                label: {
                text: point.sequence && point.driver_id
                    ? `${point.sequence}-${point.driver_id}`
                    : `${point.id.toString().slice(-3)}`,
                color: 'black',
                fontWeight: 'bold',
                fontSize: '10px',
                },
            });
            marker.addListener('click', () => handleDeliveryMarkerClick(point.id));
            setCurrentMarkers(prev => [...prev, marker]);

            // 3) if slot is present, overlay a colored “clock” icon
            if (slot >= 1 && slot <= 5) {
                const slotColor = slotColors[slot];

                // Inline SVG clock (circle + hands), fill in slotColor
                const clockSvg = `
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
                    <circle cx="8" cy="8" r="7" fill="${slotColor}" stroke="black" stroke-width="0.5"/>
                    <line x1="8" y1="8" x2="8" y2="4" stroke="black" stroke-width="1"/>
                    <line x1="8" y1="8" x2="11" y2="8" stroke="black" stroke-width="1"/>
                </svg>
                `;
                const clockIconUrl =
                'data:image/svg+xml;charset=UTF-8,' +
                encodeURIComponent(clockSvg);

                new window.google.maps.Marker({
                position,
                map: mapRef.current,
                icon: {
                    url: clockIconUrl,
                    scaledSize: new window.google.maps.Size(16, 16),
                    anchor:    new window.google.maps.Point(8, 20),
                },
                });
            }
            }
        });
        };

    const handleRecojosClick = async () => {
        console.log("Fetching orders...");
    
        clearMarkers();
    
        orderPoints.forEach(point => {
            let { latitude, longitude, status, driver_id } = point;
    
            // Check if latitude and longitude are missing
            if (!latitude || !longitude) {
                // Look for the district data
                const districtData = districts[point.distric];
                if (districtData) {
                    // Set latitude and longitude based on the district data with random offset
                    latitude = districtData.latitude + (Math.random() - 0.5) * 0.01;
                    longitude = districtData.longitude + (Math.random() - 0.5) * 0.01;
                }
            }
    
            // Only create a marker if we have valid coordinates
            if (latitude && longitude) {
                // Determine the marker color based on the status
                let color;
                if (status === 'pending') {
                    // Handle color logic when status is pending and based on driver_id
                    switch (driver_id) {
                        case 3:
                            color = 'lightblue'; // Unique color for driver_id 3
                            break;
                        case 4:
                            color = 'lightgoldenrodyellow'; // Unique color for driver_id 4
                            break;
                        case 6:
                            color = 'lightpink'; // Unique color for driver_id 6
                            break;
                        case 7:
                            color = 'peachpuff'; // Unique color for driver_id 7
                            break;
                        case 8:
                            color = 'lightcoral'; // Unique color for driver_id 8
                            break;
                        case 54:
                            color = 'lightyellow'; // Unique color for driver_id 54
                            break;
                        default:
                            color = 'gray'; // Default gray for other driver_ids or if driver_id is absent
                            break;
                    }
                } else {
                    // Use existing color logic for non-pending statuses
                    switch (status) {
                        case 'recogido':
                            color = 'green';
                            break;
                        case 'cancelado':
                            color = 'red';
                            break;
                        case 'encamino':
                            color = 'orange';
                            break;
                        default:
                            color = 'blue'; // Default color if status doesn't match any case
                    }
                }
    
                // Create a custom marker for Google Maps
                const marker = new window.google.maps.Marker({
                    position: { lat: latitude, lng: longitude },
                    map: mapRef.current,
                    icon: {
                        path: window.google.maps.SymbolPath.CIRCLE,
                        fillColor: color,
                        fillOpacity: 1,
                        scale: 12,
                        strokeColor: 'black',
                        strokeWeight: 1,
                    },
                    label: {
                        text: point.sequence && point.driver_id ? `${point.sequence}-${point.driver_id}` : `${point.id.toString().slice(-3)}`,
                        color: 'black',
                        fontWeight: 'bold',
                        fontSize: '10px',
                    },
                });
    
                marker.addListener('click', () => {
                    handleOrderMarkerClick(point.id);
                });
    
                setCurrentMarkers(prevMarkers => [...prevMarkers, marker]);
            }
        });
    };

    const handleLogoClick = () => {
        setActiveComponent('OptionsAdmin')
      }

      const handleSearchClick = () => {
        setIsSearchModalOpen(true);
    };

    const handleResumenClick = () => {
        setActiveComponent('ResumenAdmin');
    };

    const handleSearch = (result, searchType) => {
      console.log('Search result:', result);
      console.log('Search type:', searchType);
      setSearchResult({ result, searchType });
      setIsSearchModalOpen(false);
  };

  const handleDeliveryMarkerClick = (id) => {
    const result = deliveryPoints.find(point => point.id === id);
    const searchType = 'entrega_id';
    console.log('Search result:', result);
    console.log('Search type:', searchType);
    setSearchResult({ result, searchType });
    setIsSearchModalOpen(false);
  };

  const handleOrderMarkerClick = (id) => {
    const result = orderPoints.find(point => point.id === id);
    const searchType = 'recojo_id';
    console.log('Search result:', result);
    console.log('Search type:', searchType);
    setSearchResult({ result, searchType });
    setIsSearchModalOpen(false);
    };

    const handleDriverMarkerClick = async (id) => {
        try {
            const token = localStorage.getItem('token');
            // Make the API call to fetch the driver data
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/search/user`, {
                params: {
                    id: id  // Assuming the API expects 'user_id' as a query parameter
                },
                headers: { Authorization: `Bearer ${token}` },
            });
    
            // Get the driver data from the response
            const result = response.data; // Assuming the API response is the driver data
            const searchType = 'driver';
    
            // Log the result and search type
            console.log('Search result:', result);
            console.log('Search type:', searchType);
    
            // Set the search result and close the modal
            setSearchResult({ result, searchType });
            setIsSearchModalOpen(false);
        } catch (error) {
            console.error('Error fetching driver data:', error.response ? error.response.data : error.message);
            // You might want to handle errors here, e.g., show a message to the user
        }
    }; 


    const handleCloseSearchResult = () => {
        setSearchResult(null);
    };
    
    const handleRoutesClick = () => {
        onOptionClick('SearchGlobal');
    };

    const handleSendClick = () => {
        setActiveComponent('Mensajeria');
    };

    const handleMapClick = () => {
        setActiveComponent('Location');
    }; 
    
    const handleScanClick = () => {
        setActiveComponent('PackageScanner');
    }; 
    
    const handleChatClick = () => {
        setActiveComponent('Chat');
    };
    
    return (
        <div>
            <div ref={mapContainerRef} style={{ width: "100%", height: "100vh" }}></div>
            <div style={{ position: "absolute", top: "25px", left: "25px", zIndex: 2000, }} onClick={handleLogoClick} >
                <img src={`${process.env.PUBLIC_URL}/logo.png`} alt="Logo" style={{ height: "78px", width: "78px" }} />
            </div>
            <IconButton
                    style={{
                    position: "absolute",
                    bottom: "76%",
                    right: 100,
                    zIndex: 1000,
                    backgroundColor: "white",
                    border: "2px solid black",
                    borderRadius: "50%",
                    color: "black",
                    marginBottom: "10px",
                    transform: "scale(1)",
                    }}
                    onClick={handleChatClick}
                >
                    <WhatsAppIcon />
            </IconButton>
            <IconButton
                    style={{
                    position: "absolute",
                    bottom: "68%",
                    right: 100,
                    zIndex: 1000,
                    backgroundColor: "white",
                    border: "2px solid black",
                    borderRadius: "50%",
                    color: "black",
                    marginBottom: "10px",
                    transform: "scale(1)",
                    }}
                    onClick={handleScanClick}
                >
                    <QrCodeScannerIcon />
            </IconButton>
            <IconButton
                    style={{
                    position: "absolute",
                    bottom: "60%",
                    right: 100,
                    zIndex: 1000,
                    backgroundColor: "white",
                    border: "2px solid black",
                    borderRadius: "50%",
                    color: "black",
                    marginBottom: "10px",
                    transform: "scale(1)",
                    }}
                    onClick={handleMapClick}
                >
                    <MapIcon />
                </IconButton>
            <IconButton
                    style={{
                    position: "absolute",
                    bottom: "52%",
                    right: 100,
                    zIndex: 1000,
                    backgroundColor: "white",
                    border: "2px solid black",
                    borderRadius: "50%",
                    color: "black",
                    marginBottom: "10px",
                    transform: "scale(1)",
                    }}
                    onClick={handleResumenClick}
                >
                    <ChecklistIcon />
                </IconButton>
                <IconButton
                    style={{
                    position: "absolute",
                    bottom: "44%",
                    right: 100,
                    zIndex: 1000,
                    backgroundColor: "white",
                    border: "2px solid black",
                    borderRadius: "50%",
                    color: "black",
                    marginBottom: "10px",
                    transform: "scale(1)",
                    }}
                    onClick={handleSearchClick}
                >
                    <SearchIcon />
                </IconButton>
                <IconButton
                    style={{
                    position: "absolute",
                    bottom: "36%",
                    right: 100,
                    zIndex: 1000,
                    backgroundColor: "white",
                    border: "2px solid black",
                    borderRadius: "50%",
                    color: "black",
                    marginBottom: "10px",
                    transform: "scale(1)",
                    }}
                    onClick={handleSendClick}
                >
                    <SendIcon />
                </IconButton>
                <IconButton
                    style={{
                    position: "absolute",
                    bottom: "28%",
                    right: 100,
                    zIndex: 1000,
                    backgroundColor: "white",
                    border: "2px solid black",
                    borderRadius: "50%",
                    color: "black",
                    marginBottom: "10px",
                    transform: "scale(1)",
                    }}
                    onClick={handleRoutesClick}
                >
                    <SavedSearchIcon />
                </IconButton>
                <IconButton
                    style={{
                    position: "absolute",
                    bottom: "20%",
                    right: 100,
                    zIndex: 1000,
                    backgroundColor: "white",
                    border: "2px solid black",
                    borderRadius: "50%",
                    color: "black",
                    marginBottom: "10px",
                    transform: "scale(1)",
                    }}
                    onClick={handleRecojosClick}
                >
                    <PersonPinIcon />
                </IconButton>
                <IconButton
                    style={{
                    position: "absolute",
                    bottom: "10%",
                    right: 100,
                    zIndex: 1000,
                    backgroundColor: "white",
                    border: "2px solid black",
                    borderRadius: "80%",
                    color: "black",
                    marginBottom: "10px",
                    transform: "scale(1.7)",
                    }}
                    onClick={handleEntregasClick}
                >
                    <LocationOnIcon />
                </IconButton>
            
            {isSearchModalOpen && <Search onSearch={handleSearch} onClose={() => setIsSearchModalOpen(false)} />}
            
            {
              searchResult && searchResult.searchType === 'entrega_id' && (
                  <Box sx={{ position: "absolute", top: "80px", width: "70%", left: "10px", zIndex: 2000}}>
                      <SearchResultCard
                          onSearch={handleSearch}
                          deliveryPoint={searchResult.result}
                          onClose={handleCloseSearchResult}
                          userId={userId}
                      />
                  </Box>
              )
          }

          {
              searchResult && searchResult.searchType === 'recojo_id' && (
                  <Box sx={{ position: "absolute", top: "80px", width: "70%", left: "10px", zIndex: 2000 }}>
                      <SearchOrderResultCard
                          onSearch={handleSearch}
                          order={searchResult.result}
                          onClose={handleCloseSearchResult}
                      />
                  </Box>
              )
          }
        {
            searchResult && searchResult.searchType === 'user' && (
                <Box sx={{ position: "absolute", top: "80px", width: "55%", left: "10px", zIndex: 2000 }}>
                    <SearchUserResultCard
                        user={searchResult.result}
                        onClose={handleCloseSearchResult}
                    />
                </Box>
            )  
        }
        {
            searchResult && searchResult.searchType === 'driver' && (
                <Box sx={{ position: "absolute", top: "60px", width: "70%", left: "10px", zIndex: 2000 }}>
                    <SearchDriverResultCard
                        user={searchResult.result}
                        onClose={handleCloseSearchResult}
                    />
                </Box>
            )   
        }

        </div>
    );
}

export default MapAdmin;
